import { Typography } from '@mui/material';
import { AppDivider } from 'components/core/AppDivider/AppDivider';
import Grid from 'components/core/Grid';
import LoadingSkeleton from 'components/core/LoadingSkeleton/LoadingSkeleton';
import { CheckoutSectionTitle } from 'components/views/pages/Checkout/components/CheckoutSectionTitle';
import { BookingCheckoutResponse } from 'components/views/pages/Checkout/hooks/useCheckout';

interface Props {
  checkoutData: BookingCheckoutResponse | undefined;
}

export const CheckoutAccessDetails = ({ checkoutData }: Props) => {
  const isLoading = !checkoutData;

  const accessMethodName = checkoutData?.BOOKING?.PROPERTY.ACCESS_TO_UNIT.METHOD.NAME ?? 0;
  const accessTypeName = checkoutData?.BOOKING?.PROPERTY.ACCESS_TO_UNIT.TYPE.NAME ?? 0;

  return (
    <Grid item xs={12}>
      <AppDivider marginVertical="24px" />
      <LoadingSkeleton isLoading={isLoading}>
        <CheckoutSectionTitle>Access to Property</CheckoutSectionTitle>
      </LoadingSkeleton>
      <LoadingSkeleton isLoading={isLoading} scaleOneToOne>
        <Typography variant="body1">
          Entry to this property is by <strong>{accessTypeName}</strong> that will be provided by{' '}
          <strong>{accessMethodName}</strong>. You will receive detailed check-in instructions 7 days before your
          scheduled arrival date.
        </Typography>
      </LoadingSkeleton>
    </Grid>
  );
};
